// src/components/Header/SettingsButton.jsx
//
// „Setări” din josul meniului lateral și din sertarul de pe telefon, pentru
// toate rolurile: deschide fereastra Setări (tema, ieșirea din cont și, la
// elevi, aspectul). Arată ca linkurile din meniu: iconiță și text.

import React from "react";
import { ReactSVG } from "react-svg";

import { openPopup } from "../Common/popupUIStore";
import cogIcon from "../../assets/svg/mdi--cog-outline.svg";

export default function SettingsButton({ onOpen }) {
   return (
      <button
         type="button"
         className="menu__link menu__link--settings"
         onClick={() => {
            openPopup("appearanceSettings");
            onOpen?.();
         }}
      >
         <ReactSVG className="menu__icon" src={cogIcon} />
         <p className="menu__nav-text">Setări</p>
      </button>
   );
}
